import React from 'react';
import { isCertifiedIpCtsEnabled } from '../../whitelabel/certifiedMode';
import { IP_CTS_ELIGIBILITY_NOTICE, IP_CTS_EMERGENCY_NOTICE } from '../constants';
/**
 * Required IP CTS notices, shown at login when the tenant runs in certified
 * IP CTS mode. Renders nothing for non-certified tenants.
 *
 * @returns {JSX.Element | null} The notice block or null.
 */
export default function CertifiedIpCtsNotice() {
    if (!isCertifiedIpCtsEnabled()) {
        return null;
    }
    return (React.createElement("div", { className: 'certified-ipcts-notice', "data-testid": 'certified-ipcts-notice', role: 'note' },
        React.createElement("p", { className: 'certified-ipcts-notice__eligibility' }, IP_CTS_ELIGIBILITY_NOTICE),
        React.createElement("p", { className: 'certified-ipcts-notice__emergency' }, IP_CTS_EMERGENCY_NOTICE)));
}
